








import Vue from 'vue'
import { Route } from 'vue-router'

export default Vue.extend ({
  data() {
    return {
      show: true,
      label: ''
    }
  },

  watch: {
    $route(to: Route) {
      this.show = false
      setTimeout(() => {
        this.label = to.name === 'product' ? '制作事例' : to.meta.title
        this.show = true
      }, 1000)
    }
  }
})
